import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';
import i18n from 'i18next';


import af from './locales/af/translations.json';
import am from './locales/am/translations.json';
import ar from './locales/ar/translations.json';
import as from './locales/as/translations.json';
import az from './locales/az/translations.json';
import bg from './locales/bg/translations.json';
import bn_IN from './locales/bn-IN/translations.json';
import bs from './locales/bs/translations.json';
import ca from './locales/ca/translations.json';
import ca_Es_VALENCIA from './locales/ca-Es-VALENCIA/translations.json';
import cs from './locales/cs/translations.json';
import cy from './locales/cy/translations.json';
import da from './locales/da/translations.json';
import de from './locales/de/translations.json';
import el from './locales/el/translations.json';
import en from './locales/en/translations.json';
import en_GB from './locales/en-GB/translations.json';
import es from './locales/es/translations.json';
import es_MX from './locales/es-MX/translations.json';
import et from './locales/et/translations.json';
import eu from './locales/eu/translations.json';
import fa from './locales/fa/translations.json';
import fi from './locales/fi/translations.json';
import fil from './locales/fil/translations.json';
import fr from './locales/fr/translations.json';
import fr_CA from './locales/fr-CA/translations.json';
import ga from './locales/ga/translations.json';
import gd from './locales/gd/translations.json';
import gl from './locales/gl/translations.json';
import gu from './locales/gu/translations.json';
import he from './locales/he/translations.json';
import hi from './locales/hi/translations.json';
import hr from './locales/hr/translations.json';
import hu from './locales/hu/translations.json';
import hy from './locales/hy/translations.json';
import id from './locales/id/translations.json';
import is from './locales/is/translations.json';
import it from './locales/it/translations.json';
import ja from './locales/ja/translations.json';
import ka from './locales/ka/translations.json';
import kk from './locales/kk/translations.json';
import km_KH from './locales/km-KH/translations.json';
import kn from './locales/kn/translations.json';
import ko from './locales/ko/translations.json';
import kok from './locales/kok/translations.json';
import lb from './locales/lb/translations.json';
import lo from './locales/lo/translations.json';
import lt from './locales/lt/translations.json';
import lv from './locales/lv/translations.json';
import mi from './locales/mi/translations.json';
import mk from './locales/mk/translations.json';
import ml from './locales/ml/translations.json';
import mr from './locales/mr/translations.json';
import ms from './locales/ms/translations.json';
import mt from './locales/mt/translations.json';
import nb_NO from './locales/nb-NO/translations.json';
import ne from './locales/ne/translations.json';
import nl from './locales/nl/translations.json';
import nn_NO from './locales/nn-NO/translations.json';
import or from './locales/or/translations.json';
import pa from './locales/pa/translations.json';
import pl from './locales/pl/translations.json';
import pt_BR from './locales/pt-BR/translations.json';
import pt_PT from './locales/pt-PT/translations.json';
import quz from './locales/quz/translations.json';
import ro from './locales/ro/translations.json';
import ru from './locales/ru/translations.json';
import sk from './locales/sk/translations.json';
import sl from './locales/sl/translations.json';
import sq from './locales/sq/translations.json';
import sr_Cyrl_BA from './locales/sr-Cyrl-BA/translations.json';
import sr_Cyrl_RS from './locales/sr-Cyrl-RS/translations.json';
import sr_Latn_RS from './locales/sr-Latn-RS/translations.json';
import sv from './locales/sv/translations.json';
import ta from './locales/ta/translations.json';
import te from './locales/te/translations.json';
import th from './locales/th/translations.json';
import tr from './locales/tr/translations.json';
import tt from './locales/tt/translations.json';
import ug from './locales/ug/translations.json';
import uk from './locales/uk/translations.json';
import ur from './locales/ur/translations.json';
import uz_Latn_UZ from './locales/uz-Latn-UZ/translations.json';
import vi from './locales/vi/translations.json';
import zh_Hans from './locales/zh-Hans/translations.json';
import zh_Hant from './locales/zh-Hant/translations.json';

const resources = {
    'af': {
        translations: af
    },
    'am': {
        translations: am
    },
    'ar': {
        translations: ar
    },
    'as': {
        translations: as
    },
    'az': {
        translations: az
    },
    'bg': {
        translations: bg
    },
    'bn-IN': {
        translations: bn_IN
    },
    'bs': {
        translations: bs
    },
    'ca': {
        translations: ca
    },
    'ca-Es-VALENCIA': {
        translations: ca_Es_VALENCIA
    },
    'cs': {
        translations: cs
    },
    'cy': {
        translations: cy
    },
    'da': {
        translations: da
    },
    'de': {
        translations: de
    },
    'el': {
        translations: el
    },
    'en': {
        translations: en
    },
    'en-GB': {
        translations: en_GB
    },
    'es': {
        translations: es
    },
    'es-MX': {
        translations: es_MX
    },
    'et': {
        translations: et
    },
    'eu': {
        translations: eu
    },
    'fa': {
        translations: fa
    },
    'fi': {
        translations: fi
    },
    'fil': {
        translations: fil
    },
    'fr': {
        translations: fr
    },
    'fr-CA': {
        translations: fr_CA
    },
    'ga': {
        translations: ga
    },
    'gd': {
        translations: gd
    },
    'gl': {
        translations: gl
    },
    'gu': {
        translations: gu
    },
    'he': {
        translations: he
    },
    'hi': {
        translations: hi
    },
    'hr': {
        translations: hr
    },
    'hu': {
        translations: hu
    },
    'hy': {
        translations: hy
    },
    'id': {
        translations: id
    },
    'is': {
        translations: is
    },
    'it': {
        translations: it
    },
    'ja': {
        translations: ja
    },
    'ka': {
        translations: ka
    },
    'kk': {
        translations: kk
    },
    'km-KH': {
        translations: km_KH
    },
    'kn': {
        translations: kn
    },
    'ko': {
        translations: ko
    },
    'kok': {
        translations: kok
    },
    'lb': {
        translations: lb
    },
    'lo': {
        translations: lo
    },
    'lt': {
        translations: lt
    },
    'lv': {
        translations: lv
    },
    'mi': {
        translations: mi
    },
    'mk': {
        translations: mk
    },
    'ml': {
        translations: ml
    },
    'mr': {
        translations: mr
    },
    'ms': {
        translations: ms
    },
    'mt': {
        translations: mt
    },
    'nb-NO': {
        translations: nb_NO
    },
    'ne': {
        translations: ne
    },
    'nl': {
        translations: nl
    },
    'nn-NO': {
        translations: nn_NO
    },
    'or': {
        translations: or
    },
    'pa': {
        translations: pa
    },
    'pl': {
        translations: pl
    },
    'pt-BR': {
        translations: pt_BR
    },
    'pt-PT': {
        translations: pt_PT
    },
    'quz': {
        translations: quz
    },
    'ro': {
        translations: ro
    },
    'ru': {
        translations: ru
    },
    'sk': {
        translations: sk
    },
    'sl': {
        translations: sl
    },
    'sq': {
        translations: sq
    },
    'sr-Cyrl-BA': {
        translations: sr_Cyrl_BA
    },
    'sr-Cyrl-RS': {
        translations: sr_Cyrl_RS
    },
    'sr-Latn-RS': {
        translations: sr_Latn_RS
    },
    'sv': {
        translations: sv
    },
    'ta': {
        translations: ta
    },
    'te': {
        translations: te
    },
    'th': {
        translations: th
    },
    'tr': {
        translations: tr
    },
    'tt': {
        translations: tt
    },
    'ug': {
        translations: ug
    },
    'uk': {
        translations: uk
    },
    'ur': {
        translations: ur
    },
    'uz-Latn-UZ': {
        translations: uz_Latn_UZ
    },
    'vi': {
        translations: vi
    },
    'zh-Hans': {
        translations: zh_Hans
    },
    'zh-Hant': {
        translations: zh_Hant
    },
};

const i18nextInstance = i18n.createInstance();

i18nextInstance.use(initReactI18next)
    .use(LanguageDetector)
    .init({
        fallbackLng: 'en',
        supportedLngs: Object.keys(resources),
        detection: {
            order: ["path", "navigator", "localStorage", "htmlTag"],
            caches: ["localStorage"],
        },
        resources: resources,
        ns: ['translations'],
        defaultNS: 'translations',
        react: { useSuspense: false }
    });

i18nextInstance.languages = ['en'];

export default i18nextInstance;